import {SegmentedControl} from '@primer/react'
import {useMemo} from 'react'

import {pluralizeCategory} from './helpers/pluralize-category'
import type {CategoryFilterVariant} from './types'

export const ALL_CATEGORIES_SENTINEL = '__all__'

interface CategoryFilterProps {
  /** Available categories (excluding the "All" sentinel). */
  categories: string[]
  /** Current selection (`ALL_CATEGORIES_SENTINEL` for All). */
  value: string
  onChange: (next: string) => void
  /** Aria label for the segmented control. */
  ariaLabel?: string
  variant?: CategoryFilterVariant
}

export function CategoryFilter({
  categories,
  value,
  onChange,
  ariaLabel = 'Filter actors by category',
  variant,
}: CategoryFilterProps) {
  const segments = useMemo(() => [ALL_CATEGORIES_SENTINEL, ...categories], [categories])

  // 'responsive' collapses to a dropdown only on narrow viewports; regular/wide
  // fall back to the default inline segmented control.
  const segmentedControlVariant = variant === 'responsive' ? ({narrow: 'dropdown'} as const) : undefined

  return (
    <SegmentedControl aria-label={ariaLabel} size="small" variant={segmentedControlVariant}>
      {segments.map(segment => (
        <SegmentedControl.Button key={segment} selected={segment === value} onClick={() => onChange(segment)}>
          {segment === ALL_CATEGORIES_SENTINEL ? 'All' : pluralizeCategory(segment)}
        </SegmentedControl.Button>
      ))}
    </SegmentedControl>
  )
}
